import { useState } from 'react';
import ReactSimplyCarousel from 'react-simply-carousel';

import CatOne from '../../images/catamaran/ODC48-1.png';
import CatTwo from '../../images/catamaran/ODC48-2.png';
import CatFour from '../../images/catamaran/ODC48-4.png';
import CatSix from '../../images/catamaran/ODC48-6.png';
import Catfourteen from '../../images/catamaran/ODC48-14.png';
import User from '../../images/icons/user.svg';

function ReactSimplyCarouselExample() {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  return (
    <div className='carousel'>
      <ReactSimplyCarousel
        activeSlideIndex={activeSlideIndex}
        onRequestChange={setActiveSlideIndex}
        itemsToShow={1}
        itemsToScroll={1}
        forwardBtnProps={{
            className: 'pan-left material-icons'
        }}
        backwardBtnProps={{
            className: 'pan-right material-icons'
        }}
        responsiveProps={[
          {
            itemsToShow: 2,
            itemsToScroll: 2,
            minWidth: 768,
          },
        ]}
        speed={400}
        easing="linear"
      >
        {/* here you can also pass any other element attributes. Also, you can use your custom components as slides */}
        <section className='slide flex-center'>
            <img src={CatOne} alt="" />
        </section>
        <section className='slide flex-center flex-group'>
          <div className='flex-column'>
            <h2>Welcome to the OCD48</h2>
            <p>
              With a low displacement and tuned for performance without compromise on comfort, 
              she is capable of excellent sailing characteristics in lighter conditions.</p>
            <p>
              You will find yourself sailing more and motoring less which will open-up the many 
              possibilities in terms of propulsion where a fully electric set up is a reality
            </p>
          </div>
        </section>

        <section className='slide flex-center'>
            <img src={CatTwo} alt="" />
        </section>
        <section className='slide flex-center'>
          <div className='flex-column'>
            <h2>EXTERIOR</h2>
            <p>
              Stiff, Rugged and strong to weather the toughest conditions. 
              Built from marine grade aluminum which has excellent properties:
            </p>
            <ul className='bullet-list'>
              <li>
                <strong>Non-corrosive and non-toxic</strong>
              </li>
              <li>
                <strong>Easily machined and cast</strong>
              </li>
              <li>
                <strong>High Strength to weight ratio</strong> 10 times the sheer strength of fibreglass
              </li>
              <li>
                <strong>Durable and resilient</strong> with care will last a lifetime and beyond.
              </li>
              <li>
                <strong>Non-magnetic and non-sparking/non-combusting</strong>
              </li>
              <li>
                <strong>Takes to a wide range of finishes</strong> can be faired, painted, anodised, powder coated
              </li>
              <li>
                <strong>Recyclable</strong> unlike GRP, there is an afterlife to Aluminium which can simply be recycled and reused
              </li>
              <li>
                <strong>Malleable</strong> can be bent, pressed and absorbs shocks without breaking or cracking, or delaminating!
              </li>
            </ul>
              <p>
                Finish options in bare aluminium with protective coating, warp or full fairing and painting. The options are limitless.
              </p>
              <p>
                Under sail there are unobstructed views from the helm, easy access to the winches 
                and wide decks for easy  movement. All lines run back to the cockpit for short handed sailing and safety.
              </p>
          </div>
        </section>

        <section className='slide flex-center'>
            <img src={CatSix} alt="" />
        </section>
        <section className='slide flex-center'>
          <div className='flex-column'>
            <h2>Performance</h2>
            <p>
              Apart from its light displacement, there are other design considerations 
              that contribute to the ODC48's excellent performance:
            </p>
            <ul className='bullet-list'>
              <li>
                <strong>Streamlined Hull design</strong> reducing the exposed hull below the waterline to reduce drag
              </li>
              <li>
                <strong>Wake displacement</strong> The region of disturbed flow downstream of the vessel 
                caused by the flow of the water  around he hull
              </li>
              <li>
                <strong>Upwind performance</strong> use of daggerboard and optimized sail plan to sail closer 
                to the wind (not just  trade wind vessel)
              </li>
              <li>
                <strong>Bridgedeck clearance</strong> under the salon and above the waterline reducing the tendency
                of water to “slam” into the saloon floor increasing resistance and providing an unpleasant passage
              </li>
              <li>
                <strong>Windage</strong> or the air resistance on a vessel i.e. the larger the vessel area 
                above the waterline, the larger the friction it generates
              </li>
            </ul>
            <p>
              The ODC48 is designed from the ground up to optimise these elements but not compromised on comfort.
            </p>
          </div>
        </section>

        <section className='slide flex-center'>
            <img src={CatFour} alt="" />
        </section>
        <section className='slide flex-center'>
          <div className='flex-column'>
            <h2>Safety</h2>
            <p>
              The 2 main unique safety features of the ODC48 are its stiff, strong aluminium construction 
              and its performance that permits it to outrun weather. However there are many more aspects 
              of the design that speak to safety: 
            </p>
            <h4>Low profile</h4>
            <p>
              The sail work area is close to the waterline which not only improves the drive on the 
              sail but also lowers the centre of gravity of that work area making it much harder 
              to lift the windage hull out of the water.
            </p>
            <h4>Kick-up rudders</h4>
            <p>
              The rudders on the ODC48 will release and kick-up if it hits a sandbank or reef, 
              this combined with the shaft drive allows the OC48 to maneuver in 0.55M of water. 
              An added benefit is that it can readily be beached.
            </p>
          </div>
        </section>

        <section className='slide flex-center'>
            <img src={Catfourteen} alt="" />
        </section>
        <section className='slide flex-center'>
          <div className='flex-column'>
          <h2>Comfort and options</h2>
            <p>
              The ODC48 comes in 3 or 4 berth, 2 or 3 head configurations depending on your needs. 
              All beds are comfortable queen size with plenty of storage throughout.
            </p>
            <p>
              The saloon is large and spacious with plenty of seating. There is additional 
              seating options in the cockpit with a removeable table. 
            </p>
            <p>
              A forward facing navigation desk with a great view will make those night watches pass by quickly.
            </p>
            <p>
              All cabinetry is honeycomb core with veneer and hardwood edging for a great looking, 
              strong and lightweight interior.
            </p>
            <p>
              The Galley can come with 1 or 2 fridge/freezer combinations and has plenty of 
              storage space for those long passages.
            </p>
            <p>
              Space is available for a washing machine, diving gear and any other “toys” to be stowed away.
            </p>
          </div>
        </section>

        <section className='slide flex-center'>
            <img src={User} alt="" />
        </section>
        <section className='slide flex-center'>
          <div className='flex-column'>
          <h2>Keeping it simple</h2>
            <p>
              An additional safety considerations are how to make the ODC48 serviceability under 
              passage or in remote locations. As such you can expect fully labelled and easy 
              access to all wiring, plumbing, engines and through holes. Fully labelled and 
              documented trouble shooting guides are also provided. 
            </p>
            <p>
              Additionally, the steering system has been externalized as this is often a 
              troublesome area. This will profile exceptional access to fix potential problems.
            </p>
            <p>
              We took the difficult decision to buck the trend and have raised hatches as 
              default as these are less prone to leakage. Flush hatches are available on request.
            </p>
          </div>
        </section>
      </ReactSimplyCarousel>
    </div>
  );
}

export default ReactSimplyCarouselExample;